import { useAtomValue } from 'jotai'
import { usePostHog } from 'posthog-js/react'
import { FunctionComponent, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuthenticatedUser } from '~/auth/user.hooks'
import { currentScopeState } from '~/state'
import { getEnvFromUrl } from '~/utils/environment'

export type { label, prefix, TrackingLabel } from '@pubstack/ui/types/tracking'
export { normalizeAsTrackingLabel } from '@pubstack/ui/types/tracking'

export const ProductTrackingIntegration: FunctionComponent = () => {
  const user = useAuthenticatedUser()
  const currentScope = useAtomValue(currentScopeState)
  const locationHook = useLocation()
  const posthog = usePostHog()

  useEffect(() => {
    if (!user.profile.sub) return
    // Identify sends an event, so you may want to limit how often you call it
    posthog.identify(user.profile.sub, {
      email: user.profile.email,
      role: user.getScopeRole(),
      scopeId: currentScope.id,
      scopeName: currentScope.name,
      features: user.features.map((f) => f.split(':')[2]),
      viewAs: user.view,
      environment: getEnvFromUrl(window.location.host),
    })
  }, [posthog, user.profile.sub, user.profile.email, currentScope.id])

  useEffect(() => {
    if (posthog) {
      posthog.capture('$pageview', {
        $current_url: window.location.href,
      })
    }
  }, [locationHook])

  return null
}
